import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import MemberRegistrationForm from './MemberRegistrationForm';
import NonMemberRegistrationForm from "./NonMemberRegistrationForm";
import BrainCanvas from './BrainCanvas';
import './index.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams
} from "react-router-dom";
import MemberEditForm from "./MemberEditForm";
import NonMemberOnlineRegistrationForm from "./NonMemberOnlineRegistrationForm";
import MemberOnlineRegistrationForm from "./MemberOnlineRegistrationForm";

class App extends Component {

    /*
        componentDidMount() {
            var brainMesh;
            var scene = new THREE.Scene();
            var camera = new THREE.PerspectiveCamera(
                75,
                window.innerWidth / window.innerHeight,
                0.1,
                1000
            );

            var renderer = new THREE.WebGLRenderer();
            renderer.setSize(window.innerWidth, window.innerHeight);
            this.mount.appendChild(renderer.domElement);


            var animate = function () {
                requestAnimationFrame(animate);

                if (brainMesh) {
                    brainMesh.rotation.x += 0.01;
                    brainMesh.rotation.y += 0.01;
                }
                renderer.render(scene, camera);
            };

            animate();

            const controls = new OrbitControls(camera, renderer.domElement);

            camera.position.z = 100;
            /!*const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444);
            hemiLight.position.set(0, 20, 0);
            scene.add(hemiLight);*!/

            const dirLight = new THREE.DirectionalLight(0xffffff);
            dirLight.position.set(0, 0, -90);
            scene.add(dirLight);


            const ambient = new THREE.AmbientLight(0x404040, 2);
            scene.add(ambient);

            const light = new THREE.DirectionalLight(0xffffff, 2);
            light.position.set(50, 50, 100);
            scene.add(light);


            const loader = new GLTFLoader();

            loader.load(
                'https://onlineforms.kenes.com/assets/models/Brain/scene.gltf',
                // '../assets/models/Brain/scene.gltf',
                (gltf) => {
                    brainMesh = gltf.scene;
                    brainMesh.position.set(0, 0, 0);
                    scene.add(brainMesh);

                    const texture = new THREE.TextureLoader().load(
                        // './assets/models/' + item.textureFileName
                        'https://onlineforms.kenes.com/assets/models/Brain/textures/08_-_Default_baseColor.png',
                    );
                    texture.flipY = false;
                    const material = new THREE.MeshPhongMaterial({
                        map: texture,
                        color: 0xffffff,
                        skinning: true
                    });
                    brainMesh.traverse(o => {
                        if (o.isMesh) {
                            o.castShadow = true;
                            o.receiveShadow = true;
                            o.material = material;
                        }
                    });


                },
                (xhr) => {
                    // called while loading is progressing
                    console.log(`${(xhr.loaded / xhr.total * 100)}% loaded`);
                },
                (error) => {

                    // called when loading has errors
                    console.error('An error happened', error);
                },
            );


        }
    */

    render() {

        return (
            <Router basename={'/FensReg'}>
                <div>
                    {/*<NonMemberRegistrationForm/>*/}
                    {/*<NonMemberOnlineRegistrationForm/>*/}
                    {/*<MemberRegistrationForm/>*/}
                    <MemberOnlineRegistrationForm/>
                    {/*<MemberEditForm/>*/}
                    {/*<Switch>
                        <Route path="/NonMember" component={NonMemberRegistrationForm} />
                        <Route path="/Member" component={MemberRegistrationForm} />
                        <Route path="/MemberEdit" component={MemberEditForm} />
                    </Switch>*/}
                    <BrainCanvas/>
                </div>
            </Router>
        );
    }
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App/>, rootElement);
